import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { BinarbaseAPIService } from 'wflow-main-app/src/app/core/api/api/integrations/binarbase.service';
import { getOrg } from '../../utils/route.utils';

/**
 * Service managing wflow BI (binarbase) availability.
 * Uses integrations/binarbase/exists API to determine visibility.
 */
@Injectable({
  providedIn: 'root',
})
export class BinarbaseAvailabilityService {
  readonly binarbaseApiSvc = inject(BinarbaseAPIService);

  isBinarbaseBetaEnabled(_orgId?: string): Observable<boolean> {
    return this.binarbaseApiSvc
      .isOverviewBinarbaseEnabledForIdentity()
      .pipe(catchError(() => of(false)));
  }
}

export function isBinarbaseBetaEnabled(route: ActivatedRouteSnapshot) {
  const orgId = route.params?.orgId ?? getOrg();
  const svc = inject(BinarbaseAvailabilityService);

  return svc.isBinarbaseBetaEnabled(orgId);
}
